import React, {Component} from 'react';
import {Link} from "react-router-dom";
import '../FaqPages/Shipping.css'
import FocusPageId from "../../FocusPageId";

let i = 0;

class Shipping extends React.Component {
    componentDidMount() {
        // window.scrollTo(0, 0);
        let element = document.getElementById(FocusPageId.selectedId.elementId);
        element.scrollIntoView(true);
        element.classList.add('mystyle');
        // element.style.paddingTop="50px"
        window.scrollTo({
            top: document.getElementById(FocusPageId.selectedId.elementId).offsetTop - 40,
            behavior: 'smooth'
        });


    }

    constructor(props) {
        super(props);

        this.positionAdject = this.positionAdject.bind()
    };

    positionAdject = () => {
        i++;
        // if(i<3){
        //     document.getElementById(FocusPageId.selectedId.elementId).style.paddingTop="0px";

        // }

    };

    render() {

        return (
            <div className="static-pages" onWheel={() => this.positionAdject()}>
                <div className="background-div">
                    <li><h3 className="inline-block-element"><b>出荷について</b></h3></li>
                     <div className="brElement"></div>
                    <p id="a" className="bold-element all-content-font-size"> 配送業者を教えてください。
                    </p>
                    <p className='all-content-font-size'>国際宅急便SGXを利用しております。
                    </p>
                    <p className='all-content-font-size'>
                        <a href="https://www.sgh-globalj.com/index.html">
                            <text className="faq-colored-link"> SGHグローバル・ジャパン株式会社</text>
                        </a>
                    </p>

                    {/* <div className="brElement"></div>*/}
                    {/*<h4  id="a"><b> 配送業者の変更はできますか？</b>*/}
                    {/*</h4>*/}
                    {/*<p className='all-content-font-size'>誠に恐れ入りますが、配送業者の変更はできません。*/}
                    {/*</p>*/}

                     <div className="brElement"></div>
                    <h4 id="b"><b> 配送時間の指定はできますか？</b>
                    </h4>
                    <p className='all-content-font-size'>誠に恐れ入りますが、配送時間の指定はできません。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="c"><b> 受付日確定後ですが、配送先の変更はできますか？</b>
                    </h4>
                    <p className='all-content-font-size'>誠に恐れ入りますが、「受付日確定後」の変更はできかねます。予めご了承ください。
                    </p>
                     <div className="brElement"></div>
                    <h4 id="d"><b>出荷予定日より早く出荷されることはありますか？</b>
                    </h4>
                    <p className='all-content-font-size'>製造工程の都合上、ご注文いただいた出荷日より早く出荷する場合があります。
                    </p>
                    <p className='all-content-font-size'> 出荷日が短縮されたことでの追加費用はかかりませんのでご安心ください。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="e"><b> 送料はいくらですか？</b>
                    </h4>
                    <p className='all-content-font-size'>基板製造費用に送料は含まれております。
                    </p>
                    <p className='all-content-font-size'> ※いくつかのプリント基板をご注文される場合、まとめて出荷希望されますと複数割引が適用されお得です。
                    </p>
                    <p className='all-content-font-size'> ※輸送費用・日本側通関費用・関税・消費税、すべて基板製造費用に含まれておりますので、煩わしい輸入手続きを
                    </p>
                    <p className='all-content-font-size'> お客様にて行う必要がありません。
                    </p>

                     <div className="brElement"></div>
                    <h4 id='e2'><b>商品が届きません。商品の配送情報を確認したいです。</b>
                    </h4>
                    <p className='all-content-font-size'>お届け先によっては香港出荷後、お手元に届くまで3〜4日かかる場合がございます。
                    </p>
                    <p className='all-content-font-size'> アカウントページにて、配送業者とお荷物の伝票番号を記載しておりますので、お客様にて商品の追跡状況の確認が可能です。
                    </p>
                    <p className='all-content-font-size'> ※住所や建物名、宛名の一致確認が取れない場合、誤投函を防ぐため、配送業者の判断で持ち戻りとなります、再度アカウントページのプロフィールに記載されました、送り先住所に間違いが無いかご確認お願いいたします。
                    </p>
                    <p className='all-content-font-size'> ※注文確定後、送り先住所に間違いがあった場合は
                        <a onClick={()=>{document.getElementById("sub-title-span-resp").click()}}>
                            <text className="faq-colored-link"> こちらより</text>
                        </a>
                        お問合せください。
                    </p>


                     <div className="brElement"></div>
                    <h4 id="f"><b> 出荷の連絡はいただけますか？</b>
                    </h4>
                    <p className='all-content-font-size'>出荷連絡はしておりません。
                    </p>
                    <p className='all-content-font-size'> ご注文確定後は生産工程から出荷まで全ての進捗状況がアカウントページにてご確認いただけます。
                    </p>
                    <p className='all-content-font-size'> 香港出荷された商品もアカウントページにて、配送業者とお荷物の伝票番号を記載しておりますので、お客様にて商品の追跡状況の確認が可能です。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="g"><b> お届け先住所を変更したいのですが可能ですか？</b>
                    </h4>
                    <p className='all-content-font-size'>注文確定前であれば変更を承ります。
                    </p>
                    <p className='all-content-font-size'> ログイン後、アカウントページの「プロフィールの住所変更」にてご希望の住所を登録してください。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="h"><b> 海外への出荷はできますか？</b>
                    </h4>
                    <p className='all-content-font-size'>日本以外への出荷は行っておりません。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="i"><b> 別々のカートで注文した商品を同梱して出荷することは可能ですか？</b>
                    </h4>
                    {/*<p className='all-content-font-size'>ショッピングカート内で、☑チェックを入力して決済画面へ移動し*/}
                    {/*</p>*/}
                    {/*<p className='all-content-font-size'> 配送方法にて「選択したプリント基板の発送を一緒にする」に☑チェックを入れてください。*/}
                    {/*</p>*/}
                    {/*<p className='all-content-font-size'> ※いくつかのプリント基板をまとめて出荷希望されますと複数割引が適用されお得です。*/}
                    {/*</p>*/}
                    <p className='all-content-font-size'>
                        別々のカートで注文した商品は、配送を一緒にすることができません。
                    </p>
                    <p className='all-content-font-size'>
                        一緒に配送を希望される場合は、ショッピングカート内で、配送を一緒にする
                        商品に☑を入れて購入手続きへお進み下さい。
                    </p>

                    <p className='all-content-font-size'>

                        同一カートでの決済をされなかった場合、複数割引が適用されません。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="j"><b> 出荷日とは何ですか？</b>
                    </h4>
                    <p className='all-content-font-size'>商品を香港事務所から出荷する日のことをいいます。
                    </p>
                    <p className='all-content-font-size'> 製造工程の都合上、確定した出荷日より早く出荷させていただくこともございますので予めご了承ください。
                    </p>

                     <div className="brElement"></div>
                    <h4 id="k"><b> 複数箇所への配送はできますか？</b>
                    </h4>
                    <p className='all-content-font-size'>申し訳ありあません、対応しておりません。
                    </p>

                    <div className='col-md-10'></div>
                    <div className='col-md-2 col-12-custom'>
                        <Link to="/shippingTopic">
                            <span className='font-size-20'>
                            戻る
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

export default Shipping;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqPages/Shipping.js